import interactionResponse from 'await-interaction-response';

import { saveScrollPos } from '@/containers/ScrollRestoration';

export default async function handleClickableListing(event, callback, nextLink, pathname) {
    // Only do analytics and page functionality if the target was not explicitly the next/link
    // The child <H3> will be the event.target for any title link clicks
    if (!event.target.hasAttribute('data-next-link')) {

        // target and find the child next/link in the listing
        nextLink = nextLink || event?.currentTarget?.querySelector('a[data-next-link]');

        await interactionResponse();
        callback(event);
        // Save the scroll position before scrolling to the top which helps prevent layout shifts
        saveScrollPos(pathname);

        // if the event target has a next/link as a parent then we do not need to click
        // as the bubbled event will have handled that.
        if (!event.target.closest('[data-next-link]') && nextLink) {
            nextLink.click();
        }
    }
}
